/* eslint-disable no-undef */

import Cookies from 'js-cookie';
import DataReportUtil from '@util/datareport';
import { COURSE_HOME } from '@constant/path';
import { isPhone } from './index';

/**
 * 页面跳转
 */
const PageJump = {
  /**
   * 去首页
   */
  toHome() {
    window.location.href = window.location.origin;
  },
  /**
   * 去订单页
   * @param {*} groupId 课组id
   */
  toOrder(groupId) {
    window.location.href = `/m/user/confirm/${groupId}?position=0`;
  },
  /**
   * 重定向到统一登录
   * @param loginUrl {string} 统一登录域名(pc/mobile)
   * @param url {string} 选填，默认为当前url路径
   */
  redirectLogin(loginUrl = window.__INITIAL_STATE__.Config.loginUrl, url = window.location.href) {
    if (!window) {
      throw new Error('window为undefined');
    }
    sessionStorage.setItem('redirectUrlAfterLogin', window.location.pathname);
    const channel = Cookies.get('channel') || '';
    const dataReport = DataReportUtil.getLinkParam({});
    const redirectPc_url = `${`&withticket=true&channel=${channel}&redirect_url=${encodeURIComponent(
      `${window.location.protocol}//${location.host}/redirect?`
    )}`}`;
    window.location.href = `${loginUrl + redirectPc_url}${encodeURIComponent(
      `&redirect_url=${encodeURIComponent(url)}`
    )}&dataReport=${encodeURIComponent(dataReport)}`;
  },

  // 白名单类型的课组页对于非白名单用户的警告提示页
  toNoWhiteListWarn() {
    window.location.href = '/tCourse/whiteListNoAuth';
  },

  /**
   * 跳转到统一修改密码的页面(注意重定向地址的拼接)
   * @param isMobile {boolean} 默认为移动端
   */
  toResetPassword(isMobile = true) {
    if (!window) throw new Error('window为undefined');
    const { protocol, host, pathname, search } = location;
    const r1 = encodeURIComponent(`${protocol}//${host}/redirect?`); // 修改密码之后的重定向地址
    const r2 = encodeURIComponent(`&redirect_url=${encodeURIComponent(`${pathname}${search}`)}`); // 业务路由层级的重定向地址
    const redirect = `${r1}${r2}`;
    location.href = `${
      isMobile ? __INITIAL_STATE__.resetPwdUrl : __INITIAL_STATE__.resetPwdUrl_pc
    }&withticket=true&redirect_url=${redirect}`; // 只能在客户端渲染，使用 __INITIAL_STATE__
  },

  /**
   * 跳转到搜索结果页
   */
  toSearch(searchVal) {
    window.location.href = `/home/s?wd=${searchVal}`;
  },

  /**
   * 跳转到课程页
   */
  toCourse(groupId, courseId, channel = '') {
    window.location.href = `/tCourse/group/${groupId}/course/${courseId}?channel=${channel}`;
  },

  /**
   * 跳转到课程页-新窗口
   */
  openCourse(groupId, courseId, channel = '') {
    window.open(`/tCourse/group/${groupId}/course/${courseId}?channel=${channel}`);
  },

  /**
   * 跳转到课组页
   */
  toCourseGroup(groupId, channel = '') {
    window.location.href = `/tCourse/group/${groupId}?channel=${channel}`;
  },

  /**
   * 跳转到课组页-新窗口
   */
  openCourseGroup(groupId, channel = '') {
    window.open(`/tCourse/group/${groupId}?channel=${channel}`);
  },

  /**
   * 跳转到胶囊页
   */
  toCapsule(capsuleId) {
    window.location.href = `/courseview/capsule/${capsuleId}`;
  },

  /**
   * 跳转到专区
   */
  toZone(zoneId) {
    window.location.href = `/zone/${zoneId}`;
  },

  /**
   * 跳转到专区-新窗口
   */
  openZone(zoneId) {
    window.open(`/zone/${zoneId}`);
  },

  /**
   * 页面访问的返回
   * @param {string} routerUrl 指定返回的地址
   */
  routerBack(routerUrl) {
    // 记录返回的操作，附带一个过期时间；方便上一级页面确认这是返回操作(第二个参数为过期时间 10 s)
    sessionStorage.setItem('UrlHistoryBack', new Date().getTime() + 10000);
    sessionStorage.setItem('backRefresh', 'true');

    // 上一级页面刷新支持客户端渲染
    if (history && history.length > 1) {
      // 优先返回上一级页面
      if (document.referrer.indexOf('redirect') !== -1) {
        history.go(-3);
      } else {
        history.go(-1);
      }
    } else if (routerUrl) {
      // 返回到指定页面
      location.href = routerUrl;
    } else {
      this.toHome(); // 返回首页
    }
  },

  /**
   * 监听返回上一级的页面
   * @param {function} updateCB 更新回调
   */
  routerBackUpdate(updateCB = () => {}) {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        // ios 有效, android 和 pc 每次都是 false
        updateCB();
      } else if (sessionStorage.getItem('backRefresh') === 'true') {
        // ios 除外
        sessionStorage.removeItem('backRefresh');
        updateCB();
      }
    });
  },
};

export default PageJump;

export const ToLogin = ({ loginUrl, pageUrl, dataReport, isRegister = false }) => {
  if (!window) {
    throw new Error('window为undefined');
  }
  const { pathname, protocol, host } = location;
  const channel = Cookies.get('channel') || '';
  sessionStorage.setItem('redirectUrlAfterLogin', pathname); // 用于返回上一级路由的判断

  const relayPage = encodeURIComponent(`${protocol}//${host}/redirect?`); // 中继页面的地址
  const pageRedirectUrl = encodeURIComponent(pageUrl); // 业务页面的重定向 url
  const encodePageRedirectUrl = encodeURIComponent(`&redirect_url=${pageRedirectUrl}`);

  // 区分注册和登录
  const _url = isRegister
    ? // eslint-disable-next-line max-len
      `${loginUrl}&withticket=true&actionType=register&channel=${channel}&redirect_url=${relayPage}${encodePageRedirectUrl}`
    : `${loginUrl}&withticket=true&channel=${channel}&redirect_url=${relayPage}${encodePageRedirectUrl}`;

  // friday 数据的拼接
  location.href = dataReport ? `${_url}&dataReport=${encodeURIComponent(dataReport)}` : _url;
};

// pc 端登录
export function PCLogin({
  loginUrl = window.__INITIAL_STATE__.Config.loginUrl_pc,
  pageUrl = location.href,
  dataReport = '{}', // 该参数是 string 类型
} = {}) {
  let _dataReport = {};
  try {
    // 合并最新的通用上报参数
    const _commonReportData = JSON.parse(
      DataReportUtil.getLinkParam({
        pageName: window.__INITIAL_STATE__.title,
      })
    );
    _dataReport = JSON.stringify({ ...JSON.parse(dataReport), ..._commonReportData });
  } catch (e) {
    _dataReport = dataReport;
  }
  ToLogin({ loginUrl, pageUrl, dataReport: _dataReport });
}

// 移动端登录
export function MobileLogin({
  loginUrl = window.__INITIAL_STATE__.Config.loginUrl,
  pageUrl = location.href,
  dataReport = DataReportUtil.getLinkParam({
    pageName: window.__INITIAL_STATE__.title,
  }),
} = {}) {
  ToLogin({ loginUrl, pageUrl, dataReport });
}

// pc 端注册(移动端的注册入口由统一登录页面负责)
export function PCRegister(dataReport) {
  const loginUrl = window.__INITIAL_STATE__.Config.loginUrl_pc;
  const pageUrl = location.href;
  ToLogin({ loginUrl, pageUrl, isRegister: true, dataReport });
}

// 移动端和 PC 端通用的登录跳转
export function MobileOrPcLogin() {
  if (isPhone()) {
    MobileLogin();
  } else {
    PCLogin();
  }
}

/**
 * 跳转前设置当前地址作为下一个页面返回上一级的地址
 * 注：是否使用 storage 由消费者决定
 * @param {string} url 跳转到下一个页面
 */
export function JumpWithSetBack(url = '') {
  if (!url) {
    return;
  }

  sessionStorage.removeItem('back_url'); // 清除旧的设置
  sessionStorage.setItem('back_url', location.href);
  location.href = url;
}

// pc端跳转在线学习页
export function toCourseHome() {
  window.location.href = COURSE_HOME;
}

/**
 * 根据是否移动端跳转首页或者在线学习页
 * 移动端：跳转首页
 * pc端：跳转在线学习页
 */
export function skipHomeOrCourseHome() {
  if (isPhone()) {
    PageJump.toHome();
  } else {
    toCourseHome();
  }
}
